let albumPics = {
    "oahu": {
        ids: ["x38V3VO", "1xRjKuA", "h0TMtaO", "IhL4Cp3", "SNEpISi", "3zNH5ha", "ucE8tml", "dQ7ZiUl", "pE0DNkn", "IXReyfz", "ZWWYZk1", "TKQb9V3", "SICq7Ip"],
        descrip: "Taken across the island during a trip with high school friends."
    },
    "amsterdam": {
        ids: ["aHUlzlk", "sEYK47j", "ijSRe85", "9xdsnU1", "Xg86zf3", "X1GEpmd", "lvzBeT1", "b3nVuG8", "b4vGFhH", "2NHrbKi", "MPWozgm"],
        descrip: "Taken on a week-long solo trip in late September 2024."
    },
    "berlin": {
        ids: ["ZilKmKw", "m1WB0Qp", "8FgeVPt", "u4SDxnv", "OzX0Dib", "FT693TH", "9cJZheb", "77PDvUT", "WSuSgET", "4BQXu0w"],
        descrip: "Taken on a week-long solo trip in mid September 2024."
    },
    "copenhagen": {
        ids: ["7IVP1lO", "UmT4X9C", "HtN3rKk", "V3My8Zl", "W8aD3bp", "9CuyOxo", "EIho5yP", "N2R1Pdu", "lpxqyy6", "ikab1pR", "lDXTGcR", "gK0fBha", "g6i44xy", "x4hpq9y", "gh28vEU", "MGcIjKF", "ld68Koc", "pOTGrhm", "coTA8jB", "XQ1zgSZ", "vZaYe26"],
        descrip: "Taken on a week-long solo trip in early September 2024."
    },
    "ghana": {
        ids: [
            "ygA8kFN", "PEhlZn5", "yq5Tv96", "BNdclAS", "1QUnWri", "2cqXoQX", "7K8mtP3", "6BcIKgQ", "6fIcI1s", "KagD5ZG",
            "s9kjQeb", "TDPBxNW", "eAnt2Or", "GxYg6Xv", "715FGcB", "0kSegX8", "Py7UU0t", "sXiwr5O", "xiNj5nL", "K5t4nnJ",
            "njUUYnC", "uDSR6sV", "wcoaUZq", "IQp87ur", "9pBL5FF", "jDGcsXI", "lfx2R9U", "KagD5ZG", "VEj6VaX", "y6qgOht",
            "WlSI5Qb", "gRLo7TO", "yZ2xss0", "noT3577", "CgYQ6sK", "42Bns6o", "J9T7YkE"
        ],
        descrip: "Taken during my two-year Peace Corps service in Ghana, mostly in Accra, Kokrobite, Mole National Park, and my small town in the Oti Region."
    },
    "new%20england": {
        ids: ["pmwgxcF", "9wKdZAs", "23rAT0S", "gsTPt6j", "KL85OG8", "1xmjd28", "zJaELiR", "ZGYMzjx", "lTgdltJ", "6XjOpDo", "iiLYObt", "wsMLF0A", "hCOUyp2", "yaYvBim", "HxDRjgP", "Se0CsoE", "HbLzSQP", "beVNyjs", "qgDhn43", "BkWOoP0",],
        descrip: "Truthfully, many of these are not actually in Providence (Cancun and Cape Cod are also represented), but all are taken during the 4 years I spent at Brown University, and feature many of my friends from college."
    },
    "cancun": {
        ids: ["KVJnb0h", "VLL2cjI", "ot2u0pb", "8xWJGpE", "x752FKy", "dJqqgJU", "1JMYFTi", "5G3YOCB", "sDZRCgj", "tp4YJkN", "SqlQA89", "lty9nn0", "ikSwryo"],
        descrip: "Taken on a trip to Cancun with college friends."
    },
    "florida": {
        ids: ["Kw0atQE", "uYMU81H", "ksa2ldY", "iKBs90F", "DkhN7Fl", "7a67t8E", "Jx4dBaL", "KtFGoxh", "kGNW6qP", "Li3aozz", "svFXzFb", "hDypGcA", "3scUizf"],
        descrip: "Taken on a family vacation across the Florida Keys, the Everglades, and Miami.",
    },
    "san%20francisco": {
        ids: ["rj8uQ8j", "E7Vaf5B", "0NhrBQo", "xx3UE7W", "heMlWMd", "7Czz08T", "ny0lCEQ", "WJmfPCN", "mDVrMS2", "UtKrkPo", "QMmZ5qS", "UaDRrmq", "XiDQJ4k", "gQcwZ3R", "MmnnJHM", "jEjAMe6"],
        descrip: "Taken in San Francisco and around the South Bay Area, especially in Santa Clara.",
    },
    "quebec%20city": {
        ids: ["AeH2O59", "VWtcexC", "tQJ4T86", "vpiZLDn", "2AMFnxr", "BRWAon3"],
        descrip: "Taken on a road trip to Quebec City, including shots from stops along the way.",
    }
    // "illinois": {ids: [], descrip: ""},
    // "arizona": {ids: [], descrip: ""},
}

// let albumIDs = {
//     "oahu": "",
//     "amsterdam": "",
//     "berlin": "",
//     "copenhagen": "",
//     "ghana": "VwfsVLE",
//     "new%20england": "",
//     "cancun": "",
//     "florida": "",
//     "san%20francisco": "",
//     "quebec%20city": ""
//     // "illinois": "",
//     // "arizona": "",
// }

export default albumPics;
// export default albumIDs;